export class TimeService {
    private lastTimeStamp: number = performance.now();
    public deltaTime: number = 0;
    public time: number = 0;

    update() {
        const currentTime = performance.now();
        this.deltaTime = 0.001 * (currentTime - this.lastTimeStamp);
        this.time += this.deltaTime;
        this.lastTimeStamp = currentTime;
    }

    getDeltaTime() {
        return this.deltaTime;
    }
}
